import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter, withComponentInputBinding, withHashLocation, withRouterConfig } from '@angular/router';

import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { ReadService } from '@common/service/read.service';
import { httpInterceptorProviders } from '@core/interceptor/providers';
import { TmwDateParserFormatter } from '@core/service/tmw-date-parser.service';
import { TmwDatepickerI18n } from '@core/service/datepicker-i18n';
import { NgbDateParserFormatter, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { MissingTranslationHandler, TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { KeycloakService } from 'keycloak-angular';
import { ToastrModule } from 'ngx-toastr';
import { routes } from './app.routes';
import { HttpLoaderFactory, missingTranslationHandler } from './init/translate-init';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, /*withDebugTracing(),*/ withComponentInputBinding(), withHashLocation(),withRouterConfig({
      onSameUrlNavigation: 'reload',
    })),
    importProvidersFrom(BrowserModule),
    // importProvidersFrom([BrowserAnimationsModule]),
    importProvidersFrom([NoopAnimationsModule]),
    provideHttpClient(withInterceptorsFromDi()),
    KeycloakService,
    httpInterceptorProviders,
    ToastrModule.forRoot({
      timeOut: 10000,
      positionClass: 'toast-top-right', // Default position, will be dynamically changed by DynamicToastrService
      preventDuplicates: true,
      tapToDismiss: true,
      closeButton: true,
      progressBar: true,
    }).providers!,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [ReadService],
      },
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useFactory: missingTranslationHandler,
      },
    }).providers!,
    [
      {
        provide: NgbDateParserFormatter,
        useClass: TmwDateParserFormatter,
      },
      {
        provide: NgbDatepickerI18n,
        useClass: TmwDatepickerI18n,
      },
    ],
  ],
};
